<div class="modal-body text-center">
  <p
    class="fw-semi-bold fs-5"
    *ngIf="revokationRequest"
    i18n="@@patientsList_modalDeletePairing_titleTrue"
  >
    Delete pairing
  </p>
  <p
    class="fw-semi-bold fs-5"
    *ngIf="!revokationRequest"
    i18n="@@patientsList_modalDeletePairing_titleFalse"
  >
    Decline the pairing request
  </p>
  <img
    src="assets/img/img-patient-f.svg"
    class="img-fluid patient-avatar mt-5"
    *ngIf="patient.gender === gender.female; else imgMaleAvatar"
  />
  <ng-template #imgMaleAvatar>
    <img
      src="assets/img/img-patient-m.svg"
      class="img-fluid patient-avatar mt-5"
    />
  </ng-template>
  <h2 class="mt-4">{{ patient.firstName }} {{ patient.lastName }}</h2>
  <p
    class="text-gray-20 mt-5"
    *ngIf="revokationRequest"
    i18n="@@patientsList_modalDeletePairing_descriptionTrue"
  >
    Delete the pairing with this patient if this patient is no longer part of
    your patient base. By deleting this pairing, this patient's record will no
    longer appear in your list and you will no longer be able to access their
    NMOSD® data.
  </p>
  <p
    class="text-gray-20 mt-5"
    *ngIf="!revokationRequest"
    i18n="@@patientsList_modalDeletePairing_descriptionFalse"
  >
    Decline the pairing with this patient if this one is not part of your
    patient base. By declining this pairing, this patient's file will no longer
    appear in your list and you will not be able to access their NMOSD® data.
  </p>
  <div class="mt-6">
    <button
      type="button"
      (click)="removePairing()"
      class="btn btn-danger w-75 text-center m-auto text-uppercase position-relative"
    >
      <ng-lottie
        [options]="options"
        class="icon-back position-absolute top-50 translate-middle-y"
        (animationCreated)="animationCreated($event)"
      ></ng-lottie>
      <span
        *ngIf="revokationRequest"
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalDeletePairing_revokationButtonTrue"
      >
        Delete pairing
      </span>
      <span
        *ngIf="!revokationRequest"
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalDeletePairing_revokationButtonFalse"
      >
        Decline pairing
      </span>
      <!-- <span
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalDeletePairing_revokationButton"
      >
        { revokationRequest, select, true {Delete pairing} false {Decline
        pairing}}
      </span> -->
    </button>
    <button
      type="button"
      class="mt-3 btn btn-outline-primary w-75 text-center m-auto text-uppercase"
      (click)="activeModal.dismiss()"
    >
      <span
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalDeletePairing_cancelButton"
      >
        Cancel and return to list
      </span>
    </button>
  </div>
</div>
